import React from "react";
import PropTypes from "prop-types";

import DragIcon from "ui/DragIcon";

import PlatformIcon from "./PlatformIcon";
import Actions from "./Actions";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import isMobileDevice from "utils/mobileAndTabletCheck";

const Block = ({ pageElement, handleDeleteRequest, handleUpdateRequest }) => {
  
  const { content, element_type } = pageElement;

  const isMobile = isMobileDevice();

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid rgba(0,0,0,0.1)",
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "&:hover": {
          boxShadow: 2,
        },
        width: "100%",
        gap: 1,
      }}
    >
      <DragIcon />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: isMobile ? "center" : "space-between",
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!isMobile && <PlatformIcon type={element_type} />}
          <Typography variant="body1">{content}</Typography>
        </Box>

        <Actions
          onUpdate={() => handleUpdateRequest(pageElement)}
          onDelete={() => handleDeleteRequest(pageElement.id)}
        />
      </Box>
    </Box>
  );
};

Block.propTypes = {
  pageElement: PropTypes.object,
  handleDeleteRequest: PropTypes.func,
  handleUpdateRequest: PropTypes.func,
};

export default Block;
